export default __webpack_public_path__ + "static/media/NEW-GIF-CJH.ce37dbb2.gif";